<template>
    <thead class="bg-primary text-white text-sm uppercase hidden lg:table-header-group">
        <slot></slot>
    </thead>
</template>
